import styled from 'styled-components';

export const ParagraphValores = styled.p`
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  width: 100%;
`;

export const ParagraphTextoValores = styled.p`
  font-size: 10px;
  color: #fff;
  font-weight: bold;
  width: 100%;
`;

export const ContainerValores = styled.div`
  width: 30%;
  border: 1px solid #000;
  text-align: center;
  background-color: #707070;
  border-radius: 5px;
  display: flex;
  flex-flow: wrap;
`;
